module.exports = __webpack_public_path__ + "img/model_loading.98db44aa.gif";